/**
 * Every visible (or screen-reader) string of the story viewer. Nothing is
 * hard-coded in the components: apps pass these from their i18n files.
 * `{name}`-style placeholders are filled by `formatStoryLabel`.
 */
export interface StoryLabels {
  /** dialog name. Placeholders: {name} */
  storyOf: string;
  pause: string;
  resume: string;
  close: string;
  /** small flag while auto-advance is paused */
  paused: string;
  /** small flag in re-read mode */
  rereading: string;
  prevPage: string;
  nextPage: string;
  /** desktop keyboard hint under the stage */
  keysHint: string;
  /** screen-reader page announcement. Placeholders: {i} {n} {title} */
  announce: string;
  /** Placeholders: {n} */
  unitN: string;
  /** reveal page heading when the unit is known. Placeholders: {n} */
  revealKicker: string;
  /** reveal page heading without a unit (admin preview) */
  revealKickerNoUnit: string;
  /** reveal hint before the portrait appears */
  hintBefore: string;
  /** reveal hint after the portrait appears */
  hintAfter: string;
  /** notebook card: small line before the source */
  notebookCaption: string;
  /** quote card seal promise. Placeholders: {characteristic} */
  promise: string;
  /** quote card, under the promise. Placeholders: {name} (first name) */
  promiseFrom: string;
  videoPlay: string;
  videoReplay: string;
  /** hint under a video */
  videoSkip: string;
  /** shown when a video card has no video yet */
  videoEmpty: string;
  /** accessible title of an embedded (YouTube/Vimeo/Loom) player. Placeholders: {name} */
  videoFrameTitle: string;
  /** closing page heading */
  closingKicker: string;
  /** closing page first line. Placeholders: {name} (first name) */
  onWall: string;
  /** closing page next-class box. Placeholders: {n} (classes in the unit) */
  firstClass: string;
  startClass: string;
  seeWall: string;
  /** closing page: how to open the story again */
  rereadHint: string;
  /** card type names (registry `labelKey`; also announced when a card has no heading) */
  cardText: string;
  cardVideo: string;
  cardNotebook: string;
  cardQuote: string;
}

/** Fills `{key}` placeholders; unknown keys become ''. */
export function formatStoryLabel(
  template: string,
  values: Record<string, string | number | null | undefined> = {},
): string {
  return template.replace(/\{(\w+)\}/g, (_, key: string) => {
    const v = values[key];
    return v === null || v === undefined ? '' : String(v);
  });
}
